<template>
  <div class="base">
    <inside-header title="教员申请" />
    <div v-if="teacher_info.status!==0">
      <van-notice-bar v-if="teacher_info.status===2" left-icon="volume-o" text="教员您好，您的资料平台正在审核中。时间大概在两个工作日中，请耐心等待。" />
      <van-notice-bar v-if="teacher_info.status===1" left-icon="volume-o" text="教员您好，您的资料平台已审核通过。您现在可以去发布服务包啦。" />
      <van-notice-bar v-if="teacher_info.status===3" left-icon="volume-o"
        :text="`教员您好，您的资料平台未审核通过。原因：${teacher_info.reply}`" />
      <div style="padding: 15px;">
        <div>如需修改资料，请点击下面的修改资料按钮。重新修改资料后，教员身份将需要重新审核。如已发布了服务包，请谨慎操作，修改资料期间服务包将不显示。</div>
        <div style="margin-top: 10px;">
          <van-button type="warning" block @click="changeApplication">
            修改资料
          </van-button>
        </div>
      </div>
    </div>
    <div v-else style="padding-bottom: 40px;">
      <van-tabs v-model="active">
        <van-tab title="基本信息" name="baseInfo" :disabled="stepDisabled.baseInfo">
          <van-form input-align="right" @submit="onSubmit">
            <van-field readonly clickable name="type" :value="typeText" label="家教身份" @click="showPicker = true" />
            <van-popup v-model="showPicker" position="bottom">
              <van-picker show-toolbar :columns="columns" @confirm="onConfirmType" @cancel="showPicker = false" />
            </van-popup>
            <van-field readonly clickable name="current_status" :value="values" label="目前身份"
              :rules="[{ required: true, message: '请选择申请的家教身份' }]" @click="showStatus = true" />
            <van-popup v-model="showStatus" position="bottom">
              <van-picker show-toolbar :columns="columnsmoment" @confirm="onConfirmmoment"
                @cancel="showStatus = false" />
            </van-popup>
            <van-field readonly clickable name="sex" :value="valuesex" label="性别"
              :rules="[{ required: true, message: '请选择您的性别' }]" @click="showSex = true" />
            <van-popup v-model="showSex" position="bottom">
              <van-picker show-toolbar :columns="columnsSex" @confirm="onConfirmsex" @cancel="showSex = false" />
            </van-popup>
            <van-field readonly clickable name="area" :value="valueArea" label="当前地区" placeholder="请选择你所在的区域"
              @click="showArea = true" />
            <van-popup v-model="showArea" position="bottom">
              <van-area :area-list="areaList" @confirm="onConfirmArea" @cancel="showArea = false" />
            </van-popup>
            <van-field v-model="address" label="地址" name="address" placeholder="地址"
              :rules="[{ required: true, message: '请输入地址'}]" />
            <van-field v-model="currentDate" readonly clickable label="出生年月" @click="showDate = true" />
            <van-popup v-model="showDate" position="bottom">
              <van-datetime-picker show-toolbar type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
                @confirm="onConfirmDate" @cancel="showDate = false" />
            </van-popup>
            <div style="text-align:center;margin-top:50px;padding: 0 15px;">
              <van-button color="#ff5c00" native-type="submit" :loading="submitBtn" style="border-radius:10px" block>
                保存并下一步
              </van-button>
            </div>
          </van-form>
        </van-tab>
        <van-tab title="学历信息" name="educationInfo" :disabled="stepDisabled.educationInfo">
          <van-form input-align="right" @submit="educationFormHandle">
            <van-field v-model="valueSchool" name="high_school" label="就读高中" placeholder="请输入就读高中"
              :rules="[{ required: true, message: '请输入就读高中学校名称' }]" />
            <van-field readonly clickable name="highest_edu" :value="valueHighest" label="最高学历" placeholder="请选择最高学历"
              :rules="[{ required: true, message: '请选择你的最高学历' }]" @click="showEdu= true" />
            <van-popup v-model="showEdu" position="bottom">
              <van-picker show-toolbar :columns="columnsHighest" @confirm="onConfirmHighest"
                @cancel="showEdu = false" />
            </van-popup>
            <van-field v-model="School" name="school" label="就读院校" placeholder="请输入就读院校"
              :rules="[{ required: true, message: '请输入就读就读院校名称' }]" />
            <van-field v-model="valueMajor" name="major" label="所学专业" placeholder="请输入所学专业"
              :rules="[{ required: true, message: '请输入所学专业' }]" />
            <!-- 使用 title 插槽来自定义标题 -->
            <div style="padding: 10px 16px;">
              <a-row>
                <a-col :span="6">
                  学生证件
                </a-col>
                <a-col :span="18">
                  <div class="dropbox">
                    <!-- student_cert_img -->
                    <div style="float:right">
                      <a-upload action="/api/index/file/uploadProtectedImage" name="image" :multiple="false"
                        list-type="picture" :headers="headers" accept="image/png,image/jpeg"
                        :file-list="studentCertfileList" @change="uploadStudentCertHandle">
                        <a-button>
                          <a-icon type="upload" /> 上传图片
                        </a-button>
                      </a-upload>
                    </div>
                    <div>
                      <span class="ant-upload-hint" style="float:left">
                        大小：＜1MB, 像素＜500PX × 500PX
                      </span>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div style="padding: 10px 16px;">
              <a-row>
                <a-col :span="6">
                  毕业证书
                </a-col>
                <a-col :span="18">
                  <div class="dropbox">
                    <!-- student_cert_img -->
                    <div style="float:right">
                      <a-upload action="/api/index/file/uploadProtectedImage" name="image" :multiple="false"
                        list-type="picture" :headers="headers" accept="image/png,image/jpeg"
                        :file-list="diplomaCertfileList" @change="uploadDiplomaCertHandle">
                        <a-button>
                          <a-icon type="upload" /> 上传图片
                        </a-button>
                      </a-upload>
                    </div>
                    <div>
                      <span class="ant-upload-hint" style="float:left">
                        大小：＜1MB, 像素＜500PX × 500PX
                      </span>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div style="padding: 10px 16px;">
              <a-row>
                <a-col :span="6">
                  学位证件
                </a-col>
                <a-col :span="18">
                  <div class="dropbox">
                    <!-- student_cert_img -->
                    <div style="float:right">
                      <a-upload action="/api/index/file/uploadProtectedImage" name="image" :multiple="false"
                        list-type="picture" :headers="headers" accept="image/png,image/jpeg"
                        :file-list="degreedCertfileList" @change="uploadDegreeCertHandle">
                        <a-button>
                          <a-icon type="upload" /> 上传图片
                        </a-button>
                      </a-upload>
                    </div>
                    <div>
                      <span class="ant-upload-hint" style="float:left">
                        大小：＜1MB, 像素＜500PX × 500PX
                      </span>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div style="padding: 10px 16px;">
              <a-row>
                <a-col :span="6">
                  教师资格证
                </a-col>
                <a-col :span="18">
                  <div class="dropbox">
                    <!-- student_cert_img -->
                    <div style="float:right">
                      <a-upload action="/api/index/file/uploadProtectedImage" name="image" :multiple="false"
                        list-type="picture" :headers="headers" accept="image/png,image/jpeg"
                        :file-list="qualificationCertfileList" @change="uploadQualificationCertHandle">
                        <a-button>
                          <a-icon type="upload" /> 上传图片
                        </a-button>
                      </a-upload>
                    </div>
                    <div>
                      <span class="ant-upload-hint" style="float:left">
                        大小：＜1MB, 像素＜500PX × 500PX
                      </span>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div style="text-align:center;margin-top:50px;padding: 0 15px;">
              <van-button color="#ff5c00" native-type="submit" :loading="saveEducationBtn" style="border-radius:10px"
                block>
                保存并下一步
              </van-button>
              <van-button class="last-step" native-type="button" block @click="lastStep('baseInfo', 1)">
                上一步
              </van-button>
            </div>
          </van-form>
        </van-tab>
        <van-tab title="其他证书" name="otherCert" :disabled="stepDisabled.otherCert">
          <div class="get-certificate partition-area">
            <a-form :form="otherCertForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 8 }"
              @submit="otherCertFormHandle">
              <div class="tips">
                在此上传你获得的各类证书，会用作前台展示，可上传三个
              </div>
              <a-form-item :wrapper-col="{ span: 21 }">
                <div>
                  <div class="dropbox" style="width: 100%;">
                    <a-upload-dragger action="/api/index/file/uploadGeneralImage" name="image" :multiple="false"
                      list-type="picture" :headers="headers" accept="image/png,image/jpeg"
                      :file-list="oneOtherCertifileList" @change="uploadOneOtherCertifileHandle">
                      <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                      </p>
                      <p class="ant-upload-text">
                        点击上传
                      </p>
                      <p class="ant-upload-hint">
                        大小：＜1MB, 像素＜500PX × 500PX
                      </p>
                    </a-upload-dragger>
                    <!-- <a-button class="add-certificate" type="link">添加证书</a-button> -->
                  </div>
                  <div class="certificate-info">
                    <div class="title">
                      <span>名称：</span>
                      <a-input v-decorator="[
                        'other_cert_name[0]',
                        {
                          initialValue: other_cert_name.one
                        },
                      ]" placeholder="英语证书" />
                    </div>
                    <div class="description">
                      <span>描述：</span>
                      <a-textarea v-decorator="[
                        'other_cert_desc[0]',
                        {
                          initialValue: other_cert_desc.one
                        },
                      ]" placeholder="请添加描述" />
                    </div>
                  </div>
                </div>
              </a-form-item>
              <a-form-item label="第二个" :wrapper-col="{ span: 21 }">
                <div>
                  <div class="dropbox">
                    <a-upload-dragger action="/api/index/file/uploadGeneralImage" name="image" :multiple="false"
                      list-type="picture" :headers="headers" accept="image/png,image/jpeg"
                      :file-list="twoOtherCertifileList" @change="uploadTwoOtherCertifileHandle">
                      <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                      </p>
                      <p class="ant-upload-text">
                        点击上传
                      </p>
                      <p class="ant-upload-hint">
                        大小：＜1MB, 像素＜500PX × 500PX
                      </p>
                    </a-upload-dragger>
                    <!-- <a-button class="add-certificate" type="link">添加证书</a-button> -->
                  </div>
                  <div class="certificate-info">
                    <div class="title">
                      <span>名称：</span>
                      <a-input v-decorator="[
                        'other_cert_name[1]',
                        {
                          initialValue: other_cert_name.two
                        },
                      ]" placeholder="英语证书" />
                    </div>
                    <div class="description">
                      <span>描述：</span>
                      <a-textarea v-decorator="[
                        'other_cert_desc[1]',
                        {
                          initialValue: other_cert_desc.two
                        },
                      ]" placeholder="请添加描述" />
                    </div>
                  </div>
                </div>
              </a-form-item>
              <a-form-item label="第三个" :wrapper-col="{ span: 21 }">
                <div>
                  <div class="dropbox">
                    <a-upload-dragger action="/api/index/file/uploadGeneralImage" name="image" :multiple="false"
                      list-type="picture" :headers="headers" accept="image/png,image/jpeg"
                      :file-list="threeOtherCertifileList" @change="uploadThreeOtherCertifileHandle">
                      <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                      </p>
                      <p class="ant-upload-text">
                        点击上传
                      </p>
                      <p class="ant-upload-hint">
                        大小：＜1MB, 像素＜500PX × 500PX
                      </p>
                    </a-upload-dragger>
                    <!-- <a-button class="add-certificate" type="link">添加证书</a-button> -->
                  </div>
                  <div class="certificate-info">
                    <div class="title">
                      <span>名称：</span>
                      <a-input v-decorator="[
                        'other_cert_name[2]',
                        {
                          initialValue: other_cert_name.three
                        },
                      ]" placeholder="英语证书" />
                    </div>
                    <div class="description">
                      <span>描述：</span>
                      <a-textarea v-decorator="[
                        'other_cert_desc[2]',
                        {
                          initialValue: other_cert_desc.three
                        },
                      ]" placeholder="请添加描述" />
                    </div>
                  </div>
                </div>
                <div style="text-align:center;margin-top:50px;">
                  <van-button color="#ff5c00" native-type="submit" :loading="state.saveOtherCertBtn"
                    style="border-radius:10px" block>
                    保存并下一步
                  </van-button>
                  <van-button class="last-step" native-type="button" block @click="lastStep('educationInfo', 2)">
                    上一步
                  </van-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </van-tab>
        <van-tab title="授课科目" name="teachingSubjects" :disabled="stepDisabled.teachingSubjects">
          <!-- 授课范围 -->
          <div class="teaching-scope partition-area">
            <a-form :form="teachingSubjectForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
              @submit="teachingSubjectHandle">
              <a-form-item :required="true">
                <div v-if="!loading" class="study-phase">
                  <div v-for="(course_category, index) in course_data" :key="index" class="item">
                    <div>
                      <li>{{ course_category.title }}</li>
                    </div>
                    <div class="child-study-phase">
                      <a-checkbox-group v-decorator="[
                        'teaching_subjects[' + course_category.id + ']',
                        {
                          initialValue: courseListInit[course_category.id]
                        }
                      ]" :options="course_category.course_list | optionalCourses" />
                    </div>
                  </div>
                </div>
              </a-form-item>
              <a-form-item label="授课方式" :required="true
              ">
                <span>上门辅导（目前只支持上门辅导）</span>
              </a-form-item>
              <div style="text-align:center;margin-top:50px;">
                <van-button color="#ff5c00" native-type="submit" :loading="state.saveTeachingScopeBtn"
                  style="border-radius:10px" block>
                  保存并下一步
                </van-button>
                <van-button class="last-step" native-type="button" block @click="lastStep('otherCert', 3)">
                  上一步
                </van-button>
              </div>
            </a-form>
          </div>
        </van-tab>
        <van-tab title="支持区域" name="supportArea" :disabled="stepDisabled.supportArea">
          <div class="support-area partition-area">
            <a-form :form="supportAreaFrom" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
              @submit="supportAreaHandle">
              <a-form-item label="描述" :required="true">
                <a-input v-decorator="[
                  'teaching_area',
                  {
                    rules: [{ required: true, message: '请输入授课区域描述信息' }],
                    initialValue: teacher_info.teaching_area
                  }
                ]" placeholder="填写涉及到地铁线路，地标，区域描述等" />
              </a-form-item>
              <a-form-item label="地图" :required="true">
                <div class="prompt-text">
                  在地图上标记你做家教的服务范围，系统将根据标记的范围来匹配合适的家教订单
                </div>
                <div class="map">
                  <custom-map v-if="!loading" map-height="300px" :map-edit="mapEdit" :city="city" :address="address"
                    :polygon="map_polygon" :circle="map_circle" @overwriteData="mapDataHandle" />
                </div>
              </a-form-item>
              <div style="text-align:center;margin-top:50px;">
                <van-button color="#ff5c00" native-type="submit" :loading="state.saveSupportAreaBtn"
                  style="border-radius:10px" block>
                  保存并下一步
                </van-button>
                <van-button class="last-step" native-type="button" block @click="lastStep('teachingSubjects', 4)">
                  上一步
                </van-button>
              </div>
            </a-form>
          </div>
        </van-tab>
        <van-tab title="个人展示" name="personalPresent" :disabled="stepDisabled.personalPresent">
          <div class="personal-show-area partition-area">
            <div class="content">
              <a-form :form="introduceSelfForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"
                @submit="introduceSelfFormHandle">
                <a-form-item label="自我介绍" :required="true">
                  <a-textarea v-decorator="[
                    'self_evaluation',
                    {
                      rules: [{ required: true, message: '个人描述介绍不能为空' }],
                      initialValue: teacher_info.self_evaluation
                    }
                  ]" placeholder="填写对自己性格，能力的描述" />
                </a-form-item>
                <a-form-item label="视频介绍" :required="true">
                  <div class="dropbox" style="width: 100%;">
                    <a-upload-dragger action="/api/index/file/uploadGeneralFile" name="file" :multiple="false"
                      list-type="text" :headers="headers" accept="audio/mp4,video/mp4,video/mpeg"
                      :file-list="videoIntroduceFileList" @change="uploadvideoIntroduceFileHandle">
                      <p class="ant-upload-drag-icon">
                        <a-icon type="inbox" />
                      </p>
                      <p class="ant-upload-text">
                        点击上传(时长：60秒)
                      </p>
                      <p class="ant-upload-hint">
                        帧速＜630帧/秒，视频大小＜10MB 格式为：mp4/mpeg
                      </p>
                    </a-upload-dragger>
                  </div>
                  <div class="show-examples" style="margin-left: 20px;">
                    <div class="introduce">
                      上传一段60秒内的自我介绍视频，将会展示给用户<br>
                      视频需要清晰可见，背景干净整洁"
                    </div>
                  </div>
                </a-form-item>
                <div style="text-align:center;margin-top:50px;">
                  <van-button color="#ff5c00" native-type="submit" :loading="state.introduceSelBtn"
                    style="border-radius:10px" block>
                    保存
                  </van-button>
                  <van-button class="last-step" native-type="button" block @click="lastStep('supportArea', 5)">
                    上一步
                  </van-button>
                  <van-button native-type="button" :loading="state.submitApplyBtn"
                    style="border-radius:10px;margin-top: 10px;" block @click="submitApplyHandle">
                    提交申请
                  </van-button>
                </div>
              </a-form>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import { InsideHeader, CustomMap } from '@/components'
import AeraInfo from '@/assets/js/area.js'
import store from '@/store/'

const plainOptions = ['一年级', '二年级', '三年级']
const defaultCheckedList = ['一年级', '三年级']

export default {
  name: 'TeacherMembersApply',
  components: {
    InsideHeader,
    CustomMap
  },
  filters: {
    optionalCourses(courses) {
      var optionArr = []
      courses.forEach((item, index, array) => {
        optionArr.push(item.title)
      })
      return optionArr
    }
  },
  data() {
    return {
      loading: true,
      step: 'baseInfo',
      active: 'baseInfo',
      headers: {
        authorization: store.getters.token
      },
      state: {
        saveBaseBtn: false,
        saveEducationBtn: false,
        saveOtherCertBtn: false,
        saveTeachingScopeBtn: false,
        saveSupportAreaBtn: false,
        introduceSelBtn: false,
        submitApplyBtn: false
      },
      stepDisabled: {
        baseInfo: true,
        educationInfo: true,
        otherCert: true,
        teachingSubjects: true,
        supportArea: true,
        personalPresent: true
      },
      value: '',
      columns: [{ text: '在校教员', value: 'part_time' }, { text: '专职教员', value: 'full_time' }],
      typeText: '',
      typeValue: '',
      showPicker: false,
      values: '',
      showStatus: false,
      teacher_info: {},
      //   columnsmoment: ['大学生', '研究生', '博士生', '其他'],
      columnsSex: ['男', '女'],
      showSex: false,
      valuesex: '',
      showArea: false,
      valueArea: '',
      areaList: AeraInfo,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(2003, 11, 31),
      currentDate: '',
      showDate: false,
      submitBtn: false,
      birth_month: 0,
      birth_year: 0,
      valueSchool: '',
      columnsHighest: ['专科', '本科', '研究生', '博士'],
      showEdu: false,
      valueHighest: '',
      School: '',
      valueMajor: '',
      // 上传的学生证，提交
      student_cert_img: {},
      // 毕业证，提交
      diploma_cert_img: {},
      // 学位证，提交
      degree_cert_img: {},
      // 教师资格证，提交
      teacher_qualification_cert: {},
      // 学生证文件列表,上传列表
      studentCertfileList: [],
      // 毕业证,上传列表
      diplomaCertfileList: [],
      // 学位证,上传列表
      degreedCertfileList: [],
      // 教师资格证,上传列表
      qualificationCertfileList: [],
      saveEducationBtn: false,
      // 其他所获证书
      otherCertForm: this.$form.createForm(this, { name: 'other-cert' }),
      // 其他证书，提交
      certificate_list: {},
      // 第一个证书
      one_other_cert_img: {},
      oneOtherCertifileList: [],
      // 第二个证书
      two_other_cert_img: {},
      twoOtherCertifileList: [],
      // 第三个证书
      three_other_cert_img: {},
      threeOtherCertifileList: [],
      // 证书名和描述的初始值
      other_cert_name: {
        one: '',
        two: '',
        three: ''
      },
      other_cert_desc: {
        one: '',
        two: '',
        three: ''
      },
      // 授课范围
      // form
      teachingSubjectForm: this.$form.createForm(this, { name: 'teaching-subject' }),
      // 可授课科目,后台数据
      course_data: [],
      // 初始值
      courseListInit: {
        2: ['语文', '数学'],
        3: ['语文', '数学'],
        4: ['语文', '数学', '英语']
      },
      // 区域设置
      supportAreaFrom: this.$form.createForm(this, { name: 'support-area' }),
      teachingAreaMap: {},
      // 个人展示
      introduceSelfForm: this.$form.createForm(this, { name: 'introduce-self' }),
      teaching_video: {},
      videoIntroduceFileList: [],
      // 选着授课科目
      checkedList: defaultCheckedList,
      checkAll: false,
      plainOptions,
      // 地图
      mapEdit: true, // 编辑地图
      city: '广安市',
      address: '',
      map_circle: [],
      map_polygon: []
    }
  },
  computed: {
    columnsmoment: function () {
      if (this.teach_type === 'part_time') {
        return ['大学生', '研究生', '博士生', '其他']
      } else {
        console.log(2)
        return ['学校教师', '培训教师', '其他']
      }
    }
  },
  watch: {
    step(val) {
      this.stepDisabled.baseInfo = true
      this.stepDisabled.educationInfo = true
      this.stepDisabled.otherCert = true
      this.stepDisabled.teachingSubjects = true
      this.stepDisabled.supportArea = true
      this.stepDisabled.personalPresent = true

      switch (val) {
        case 'baseInfo':
          this.stepDisabled.baseInfo = false
          break
        case 'educationInfo':
          this.stepDisabled.educationInfo = false
          console.log(this.stepDisabled)
          break
        case 'otherCert':
          this.stepDisabled.otherCert = false
          break
        case 'teachingSubjects':
          this.stepDisabled.teachingSubjects = false
          break
        case 'supportArea':
          this.stepDisabled.supportArea = false
          break
        case 'personalPresent':
          this.stepDisabled.personalPresent = false
          break
      }
      const _this = this
      setTimeout(function () {
        _this.active = val
      }, 1)
    },
    teacher_info(val) {
      this.teach_type = val.type

      // 学生证
      if (val.student_cert_img) {
        this.studentCertfileList = []
        this.student_cert_img = JSON.parse(val.student_cert_img)
        this.studentCertfileList.push(val.student_cert_img_info)
      }
      // 毕业证
      if (val.diploma_cert_img) {
        this.diplomaCertfileList = []
        this.diploma_cert_img = JSON.parse(val.diploma_cert_img)
        this.diplomaCertfileList.push(val.diploma_cert_img_info)
      }
      // 学位证
      if (val.degree_cert_img) {
        this.degreedCertfileList = []
        this.degree_cert_img = JSON.parse(val.degree_cert_img)
        this.degreedCertfileList.push(val.degree_cert_img_info)
      }
      // 教师资格证
      if (val.teacher_qualification_cert) {
        this.qualificationCertfileList = []
        this.teacher_qualification_cert = JSON.parse(val.teacher_qualification_cert)
        this.qualificationCertfileList.push(val.teacher_qualification_cert_info)
      }

      // 其他展示证书
      if (val.certificate_list) {
        var certificateList = JSON.parse(val.certificate_list)
        var certificateListInfo = val.certificate_list_info
        this.certificate_list = certificateList
        //
        if (certificateList[0] !== undefined) {
          this.one_other_cert_img = certificateList[0]
          if (certificateListInfo[0] !== undefined) {
            this.oneOtherCertifileList = []
            this.oneOtherCertifileList.push(certificateListInfo[0].file)
            this.other_cert_name.one = certificateListInfo[0].name
            this.other_cert_desc.one = certificateListInfo[0].desc
          }
        }

        if (certificateList[1] !== undefined) {
          this.two_other_cert_img = certificateList[1]
          if (certificateListInfo[1] !== undefined) {
            this.twoOtherCertifileList = []
            this.twoOtherCertifileList.push(certificateListInfo[1].file)
            this.other_cert_name.two = certificateListInfo[1].name
            this.other_cert_desc.two = certificateListInfo[1].desc
          }
        }

        if (certificateList[2] !== undefined) {
          this.three_other_cert_img = certificateList[2]
          if (certificateListInfo[2] !== undefined) {
            this.threeOtherCertifileList = []
            this.threeOtherCertifileList.push(certificateListInfo[2].file)
            this.other_cert_name.three = certificateListInfo[2].name
            this.other_cert_desc.three = certificateListInfo[2].desc
          }
        }
      }

      // 设置的授课科目
      if (val.teaching_subjects) {
        var teachingSubjSects = JSON.parse(val.teaching_subjects)
        this.courseListInit = teachingSubjSects
      }

      // 地图定点
      if (val.province) {
        this.mapSpotHandle(val.province, val.city, val.area, val.address)
      }

      // 地图上授课区域
      if (val.teaching_area_map) {
        this.teachingAreaMap = val.teaching_area_map
        // 后台解析好的
        var teachingAreaMapInfo = val.teaching_area_map_info
        this.map_circle = teachingAreaMapInfo.circle
        this.map_polygon = teachingAreaMapInfo.polygon
      }

      // 介绍视频
      if (val.teaching_video) {
        this.videoIntroduceFileList = []
        this.teaching_video = JSON.parse(val.teaching_video)
        this.videoIntroduceFileList.push(val.teaching_video_info)
      }
    },
    studentCertfileList(val) {
      console.log(333, val)
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
  },
  methods: {
    loadData() {
      // 加载数据
      this.loading = true
      new Promise((resolve, reject) => {
        this.$http({
          url: '/index/teacher/teacherInfo',
          method: 'get',
          params: {
          }
        }).then(res => {
          this.loading = false
          if (res.status === 'success') {
            const data = res.data
            var type = data.teacher_info.type
            this.countryDivision = data.country_division
            this.teacher_info = data.teacher_info
            // 可授课科目
            this.course_data = data.course_data
            // 大学数据，太大了
            // this.colleges_universities = data.colleges_universities
            this.values = data.teacher_info.current_status
            this.valuesex = data.teacher_info.sex
            this.valueArea = data.teacher_info.province + '/' + data.teacher_info.city + '/' + data.teacher_info.area
            this.address = data.teacher_info.address
            this.currentDate = data.teacher_info.birth_year + '年' + data.teacher_info.birth_month + '月'
            this.birth_month = data.teacher_info.birth_month
            this.birth_year = data.teacher_info.birth_year
            this.valueSchool = data.teacher_info.high_school
            this.valueHighest = data.teacher_info.highest_edu
            this.School = data.teacher_info.school
            this.valueMajor = data.teacher_info.major
            this.student_cert_img = data.teacher_info.student_cert_img
            this.step = data.teacher_info.step
            if (type === 'part_time') {
              this.typeText = '在校教员'
              this.typeValue = 'part_time'
            } else if (type === 'full_time') {
              this.typeValue = 'full_time'
              this.typeText = '专职教员'
            }
            resolve(data.teacher_info)
          } else {
            this.$notification.error({
              message: '系统繁忙，请刷新重试',
              description: ''
            })
          }
        })
      }).then(teacherInfo => {
        // 加载学生证
        return this.syncStudentCertImage(teacherInfo)
      }).then(teacherInfo => {
        // 加载毕业证
        return this.syncdiplomaCertImage(teacherInfo)
      }).then(teacherInfo => {
        // 加载学位证
        return this.syncdegreedCertImage(teacherInfo)
      }).then(teacherInfo => {
        // 加载教师资格证
        return this.syncqualificationCertImage(teacherInfo)
      })
    },
    // 异步加载学生证图片（原因：受到保护的，需要携带token获取）
    syncStudentCertImage(teacherInfo) {
      const winThis = this
      var p = new Promise(function (resolve, reject) {
        const studentCertImgInfo = teacherInfo.student_cert_img_info
        // 存在
        if (Object.keys(studentCertImgInfo).length !== 0) {
          const url = studentCertImgInfo.url
          winThis.$http({
            url: url,
            method: 'get',
            params: {
            }
          }).then(res => {
            winThis.studentCertfileList[0].url = res
          })
        }

        resolve(teacherInfo)
      })
      return p
    },
    // 毕业证
    syncdiplomaCertImage(teacherInfo) {
      const winThis = this
      var p = new Promise(function (resolve, reject) {
        const diplomaCertImgInfo = teacherInfo.diploma_cert_img_info
        // 存在
        if (Object.keys(diplomaCertImgInfo).length !== 0) {
          const url = diplomaCertImgInfo.url
          winThis.$http({
            url: url,
            method: 'get',
            params: {
            }
          }).then(res => {
            winThis.diplomaCertfileList[0].url = res
          })
        }

        resolve(teacherInfo)
      })
      return p
    },
    // 学位证
    syncdegreedCertImage(teacherInfo) {
      const winThis = this
      var p = new Promise(function (resolve, reject) {
        const degreeCertImgInfo = teacherInfo.degree_cert_img_info
        // 存在
        if (Object.keys(degreeCertImgInfo).length !== 0) {
          const url = degreeCertImgInfo.url
          winThis.$http({
            url: url,
            method: 'get',
            params: {
            }
          }).then(res => {
            winThis.degreedCertfileList[0].url = res
          })
        }

        resolve(teacherInfo)
      })
      return p
    },
    // 教师资格证
    syncqualificationCertImage(teacherInfo) {
      const winThis = this
      var p = new Promise(function (resolve, reject) {
        const teacherQualificationCertInfo = teacherInfo.teacher_qualification_cert_info
        // 存在
        if (Object.keys(teacherQualificationCertInfo).length !== 0) {
          const url = teacherQualificationCertInfo.url
          winThis.$http({
            url: url,
            method: 'get',
            params: {
            }
          }).then(res => {
            winThis.qualificationCertfileList[0].url = res
          })
        }

        resolve(teacherInfo)
      })
      return p
    },
    teachTypeChange(e) {
      this.teach_type = e
    },
    onConfirmType(obj) {
      console.log(obj)
      this.teach_type = obj.value
      this.typeText = obj.text
      this.typeValue = obj.value
      this.showPicker = false
    },
    onConfirmmoment(value) {
      this.values = value
      this.showStatus = false
    },
    onConfirmsex(value) {
      this.valuesex = value
      this.showSex = false
    },
    onConfirmArea(value) {
      this.valueArea = value
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.showArea = false
    },
    onConfirmDate(time) {
      console.log(time)
      var year = time.getFullYear()
      var month = time.getMonth() + 1
      var day = time.getDate()
      this.currentDate = year + '年' + month + '月' + day + '日'
      this.showDate = false
      this.birth_month = month
      this.birth_year = year
    },
    onConfirmHighest(value) {
      console.log(value)
      this.valueHighest = value
      this.showEdu = false
    },
    // uploadStudentCertHandle (e) {
    //   console.log(e)
    //   if (e.file.status !== 'uploading') {
    //     console.log(e.file, e.fileList)
    //   }
    //   if (e.file.status === 'done') {
    //     this.$message.success(`${e.file.name} file uploaded successfully`)
    //   } else if (e.file.status === 'error') {
    //     this.$message.error(`${e.file.name} file upload failed.`)
    //   }
    // },
    // 上传学生证，然后只能上传一个，这里作为的是上传成功后，需要将值放到name上的内容
    uploadStudentCertHandle(e) {
      console.log(1, e)
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$toast.success(`${e.file.name} 文件上传成功`)
          this.student_cert_img = response.data
        } else {
          this.$toast.fail(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 如果点击了删除图片
      if (e.file.status === 'removed') {
        this.student_cert_img = {}
      }
      const oneFileList = e.fileList.slice(-1)
      this.studentCertfileList = oneFileList
      console.log(3, oneFileList)
    },
    // 上传毕业证
    uploadDiplomaCertHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$toast.success(`${e.file.name} 文件上传成功`)
          this.diploma_cert_img = response.data
        } else {
          this.$toast.fail(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 如果点击了删除图片
      if (e.file.status === 'removed') {
        this.diploma_cert_img = {}
      }
      const oneFileList = e.fileList.slice(-1)
      this.diplomaCertfileList = oneFileList
    },
    // 上传学位证
    uploadDegreeCertHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$toast.success(`${e.file.name} 文件上传成功`)
          this.degree_cert_img = response.data
        } else {
          this.$toast.fail(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 如果点击了删除图片
      if (e.file.status === 'removed') {
        this.degree_cert_img = {}
      }
      // 只留一个
      const oneFileList = e.fileList.slice(-1)
      this.degreedCertfileList = oneFileList
    },
    // 教师资格证
    uploadQualificationCertHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$toast.success(`${e.file.name} 文件上传成功`)
          this.teacher_qualification_cert = response.data
        } else {
          this.$toast.fail(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 如果点击了删除图片
      if (e.file.status === 'removed') {
        this.teacher_qualification_cert = {}
      }
      // 只留一个
      const oneFileList = e.fileList.slice(-1)
      this.qualificationCertfileList = oneFileList
    },
    // 保存基本信息
    onSubmit(value) {
      // 修改type为保存到data中的英文显示
      value.type = this.typeValue
      var string = this.valueArea
      var area = string.split('/')
      value.area = area
      value.birth_month = this.birth_month
      value.birth_year = this.birth_year
      value.type = this.typeValue

      console.log(value)
      this.$http({
        url: 'index/teacher/applyBase',
        method: 'post',
        data: value
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          this.$toast('保存成功')
          // 跳转到下一步
          this.step = 'educationInfo'
          setTimeout(function () {
            document.getElementsByClassName('van-tab')[1].click()
          }, 1)
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    // 学历数据保存
    educationFormHandle(values) {
      console.log(1, values)
      //   e.preventDefault() // 关闭默认提交的行为 将图片保存到变量里面,然后在提交时将变量存到values里面
      values.student_cert_img = this.student_cert_img
      values.diploma_cert_img = this.diploma_cert_img
      values.degree_cert_img = this.degree_cert_img
      values.teacher_qualification_cert = this.teacher_qualification_cert
      this.saveEducationBtn = true
      this.$http({
        url: '/index/teacher/applyEducation',
        method: 'post',
        data: values
      }).then(res => {
        this.saveEducationBtn = false
        if (res.status === 'success') {
          this.$toast('保存成功')
          // 跳转到下一步
          this.step = 'otherCert'
          setTimeout(function () {
            document.getElementsByClassName('van-tab')[2].click()
          }, 1)
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    // 其他证书上传，第一个
    uploadOneOtherCertifileHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$message.success(`${e.file.name} 文件上传成功`)
          this.one_other_cert_img = response.data
        } else {
          this.$message.error(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 只留一个
      const oneFileList = e.fileList.slice(-1)
      this.oneOtherCertifileList = oneFileList
    },
    // 其他证书上传，第二个
    uploadTwoOtherCertifileHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$message.success(`${e.file.name} 文件上传成功`)
          this.two_other_cert_img = response.data
        } else {
          this.$message.error(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 只留一个
      const oneFileList = e.fileList.slice(-1)
      this.twoOtherCertifileList = oneFileList
    },
    // 其他证书上传，第三个
    uploadThreeOtherCertifileHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$message.success(`${e.file.name} 文件上传成功`)
          this.three_other_cert_img = response.data
        } else {
          this.$message.error(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 只留一个
      const oneFileList = e.fileList.slice(-1)
      this.threeOtherCertifileList = oneFileList
    },
    // 其他证书上传
    otherCertFormHandle(e) {
      e.preventDefault()
      this.otherCertForm.validateFields((err, values) => {
        if (!err) {
          // 上传的证书资源对象
          var certificatList = []
          // 存在第一个证书文件，名称和描述有效
          if (Object.keys(this.one_other_cert_img).length !== 0) {
            var oneImg = {}
            oneImg.resource_id = this.one_other_cert_img.resource_id
            oneImg.name = values.other_cert_name[0]
            oneImg.desc = values.other_cert_desc[0]
            certificatList.push(oneImg)
          }
          // 存在第二个证书文件，名称和描述有效
          if (Object.keys(this.two_other_cert_img).length !== 0) {
            var twoImg = {}
            twoImg.resource_id = this.two_other_cert_img.resource_id
            twoImg.name = values.other_cert_name[1]
            twoImg.desc = values.other_cert_desc[1]
            certificatList.push(twoImg)
          }

          // 存在第三个证书文件，名称和描述有效
          if (Object.keys(this.three_other_cert_img).length !== 0) {
            var threeImg = {}
            threeImg.resource_id = this.three_other_cert_img.resource_id
            threeImg.name = values.other_cert_name[2]
            threeImg.desc = values.other_cert_desc[2]
            certificatList.push(threeImg)
          }

          // 没有内容
          if (certificatList.length === 0) {
            this.$notification.error({
              message: '不能保存',
              description: '未上传任何证书'
            })
            return false
          }
          this.certificate_list = certificatList

          this.state.saveOtherCertBtn = true
          this.$http({
            url: '/index/teacher/applyOtherCert',
            method: 'post',
            data: { certificate_list: certificatList }
          }).then(res => {
            this.state.saveOtherCertBtn = false
            if (res.status === 'success') {
              this.$toast.success('保存成功')
              // 跳转到下一步
              this.step = 'teachingSubjects'
              setTimeout(function () {
                document.getElementsByClassName('van-tab')[3].click()
              }, 1)
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    },
    // 授课范围
    teachingSubjectHandle(e) {
      e.preventDefault()
      this.teachingSubjectForm.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          this.state.saveTeachingScopeBtn = true
          this.$http({
            url: '/index/teacher/applyTeachingSubjects',
            method: 'post',
            data: values
          }).then(res => {
            this.state.saveTeachingScopeBtn = false
            if (res.status === 'success') {
              this.$toast.success('保存成功')
              // 跳转到下一步
              this.step = 'supportArea'
              setTimeout(function () {
                document.getElementsByClassName('van-tab')[4].click()
              }, 1)
            } else {
              this.$toast.success(res.message)
            }
          })
        }
      })
    },
    // 处理省，市，区，地址到地图
    mapSpotHandle(province, city, area, address) {
      var isMunicipality = this.inArray(province, ['北京市', '重庆市', '天津市', '上海市'])

      if (isMunicipality) {
        this.city = province
        this.address = city + address
      } else {
        this.city = city
        this.address = area + address
      }
    },
    // 地图数据，存储到数据库中。前台使用
    mapDataHandle(e) {
      this.teachingAreaMap = e
    },
    // 授课地点提交
    supportAreaHandle(e) {
      e.preventDefault()
      this.supportAreaFrom.validateFields((err, values) => {
        if (!err) {
          values.teaching_area_map = this.teachingAreaMap
          this.state.saveSupportAreaBtn = true
          this.$http({
            url: '/index/teacher/applyTeachingArea',
            method: 'post',
            data: values
          }).then(res => {
            this.state.saveSupportAreaBtn = false
            if (res.status === 'success') {
              this.$toast.success('保存成功')
              // 跳转到下一步
              this.step = 'personalPresent'
              setTimeout(function () {
                document.getElementsByClassName('van-tab')[5].click()
              }, 1)
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    },
    // 个人展示视频上传
    // 教师资格证
    uploadvideoIntroduceFileHandle(e) {
      // 上传已成功
      if (e.file.status === 'done') {
        const response = e.file.response
        // 上传成功，将返回值放到上传值中
        if (response.status === 'success') {
          this.$message.success(`${e.file.name} 文件上传成功`)
          this.teaching_video = response.data
        } else {
          this.$message.error(`${e.file.name} 文件上传失败, 原因:` + response.message)
        }
      }
      // 只留一个
      const oneFileList = e.fileList.slice(-1)
      this.videoIntroduceFileList = oneFileList
    },
    introduceSelfFormHandle(e) {
      e.preventDefault()
      this.introduceSelfForm.validateFields((err, values) => {
        if (!err) {
          console.log(values)
          values.teaching_video = this.teaching_video
          this.state.introduceSelBtn = true
          this.$http({
            url: '/index/teacher/applyIntroduceSelf',
            method: 'post',
            data: values
          }).then(res => {
            this.state.introduceSelBtn = false
            if (res.status === 'success') {
              this.$toast.success('保存成功')
              // 重新加载
              // this.loadData()
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    },
    // 提交申请
    submitApplyHandle(e) {
      this.$dialog.confirm({
        title: '注意',
        message: '请确认选项卡所有信息都已正确填写'
      }).then(() => {
        this.state.submitApplyBtn = true
        this.$http({
          url: '/index/teacher/submitApplication',
          method: 'post',
          data: { submit: true }
        }).then(res => {
          this.state.submitApplyBtn = false
          if (res.status === 'success') {
            this.$toast.success('申请提交成功，请等待后台审核')
            // 重新加载
            this.loadData()
          } else {
            this.$toast.fail(res.message)
          }
        })
      }).catch(() => {

      })
    },
    changeApplication(e) {
      this.$dialog.confirm({
        title: '注意',
        message: '后台将会重新审核教员资格'
      }).then(() => {
        this.$http({
          url: '/index/teacher/changeApplication',
          method: 'post',
          data: { submit: true }
        }).then(res => {
          if (res.status === 'success') {
            // this.$toast.success('申请提交成功，请等待后台审核')
            // 重新加载
            this.loadData()
          } else {
            this.$toast.fail(res.message)
          }
        })
      }).catch(() => {

      })
    },
    lastStep(lastName, index) {
      // 跳转到下一步
      this.step = lastName
      setTimeout(function () {
        document.getElementsByClassName('van-tab')[index].click()
      }, 1)
    }
  }
}
// 流程：上传图片保存到变量里面，然后提交时将变量给提交给后台的数据里
</script>
<style scoped lang="stylus">
  .get-certificate {
    padding: 10px 15px;
    .tips {
      padding-bottom: 10px;
    }

    .ant-form-item-children {
      overflow hidden
    }

    .add-certificate {
      padding-left: 0px;
      margin-top: 20px;
    }

    .certificate-info {
      margin-top: 10px;
      .title {
        span {
          display: inline-block;
          width: 13%;
        }
        input {
          width: 87%;
          // width: 250px;
        }
      }

      .description {
        overflow hidden

        span {
          float: left;
          display: inline-block;
          width: 13%;
        }

        textarea {
          float: left;
          width: 87%;
          height: 75px;
          margin-top: 10px;
        }
      }
    }
  }

  // 授课范围
  .teaching-scope {
    padding: 10px 15px;

    .child-study-phase {
      margin-left: 28px;
    }
  }

  // 支持区域
  .support-area {
    padding: 10px 15px;

  }

  // 个人展示
  .personal-show-area {
    padding: 10px 15px;

    .content {
      margin-top: 17px;

      textarea {
        height: 100px;
        border-radius: 4px;
        border: solid 1px #f3f3f3;
      }

      .introduce {
        font-family: MicrosoftYaHeiLight;
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #666666;
      }
    }
  }

  .last-step {
    margin-top: 10px;
    border-radius:10px
  }
</style>
